import { extraExtraLargeScreen, largeScreen, mediumScreen, smallScreen } from 'common/theme'
import { Col } from 'react-bootstrap'
import styled from 'styled-components'

export const Container = styled.div`
  margin: 0 auto;
  padding: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.fontBase};

  @media (max-width: ${mediumScreen}) {
    padding: 1.5rem;
  }
`

export const SearchCard = styled.div`
  border: 1px solid #ddd;
  margin-bottom: 15px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  @media (max-width: ${mediumScreen}) {
    .row {
      flex-direction: column;
      display: flex;
      margin: 0;
    }
    .col,
    .col-sm-6,
    .col-md-6,
    .col-lg-6 {
      max-width: 100%;
      flex: none;
      margin-bottom: 10px;
    }
  }
`

export const CloseButtonStyled = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  z-index: 10;
  border-radius: 3px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${mediumScreen}) {
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
`

export const SearchTitle = styled.h4`
  padding: 15px 20px;
  margin: 0;
  font-size: large;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 500;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  @media (max-width: ${mediumScreen}) {
    padding: 10px 15px;
    font-size: medium;
  }
`

export const SearchCount = styled.text`
  color: ${({ theme }) => theme.colors.primary};
  font-size: large;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;

  .loader,
  [class*='loader'] {
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    margin: 0 2px;
  }
  .spinner {
    display: inline-block;
    vertical-align: middle;
  }
`

export const SearchActions = styled(Col)`
  display: flex;
  justify-content: end;
  /* flex-direction: column; */
  align-items: flex-end;
  margin-right: 25px;

  @media (max-width: ${mediumScreen}) {
    margin-right: 0;
    margin-top: 15px;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    padding: 0 15px;

    .row {
      margin: 0;
      width: auto;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex: 1;
    }
  }
`

export const EditActions = styled.div`
  padding: 15px 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: ${mediumScreen}) {
    padding: 0 15px 10px 15px;
    /* flex-direction: column; */
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    align-items: flex-start;
  }
`

export const ActionLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  &:hover {
    color: ${({ theme }) => theme.colors.colorButtonDisabled};
  }
`

export const SearchButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  padding: 8px 16px;
  margin-bottom: 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDarken};
  }

  @media (max-width: ${mediumScreen}) {
    margin-bottom: 0;
    padding: 10px 20px;
    font-size: 14px;
    /* min-width: 120px; */
    width: 100%;
  }
`

export const SearchContent = styled.div`
  padding: 15px 20px;
  background-color: white;

  @media (max-width: ${mediumScreen}) {
    padding: 10px 15px;
  }
`

export const SearchInfo = styled.div`
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
`

export const CriteriaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 10px;

  @media (max-width: ${mediumScreen}) {
    grid-template-columns: none;
    gap: 6px;
  }
`

export const CriteriaItem = styled.div`
  font-size: 14px;
  display: flex;
  gap: 5px;
`

export const CriteriaLabel = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
`

export const CriteriaValue = styled.span`
  color: ${({ theme }) => theme.colors.primary};
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
`

export const EditActionContainer = styled.div`
  position: relative;
  display: inline-block;
  width: max-content;
`

export const PopoverOverlay = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  margin-top: 5px;
  min-width: 450px;
  width: 90vw;
  max-width: 500px;

  @media (max-width: ${mediumScreen}) {
    transform: translateX(-15%);
    min-width: auto;
    max-width: 400px;
    left: 40%;
  }

  @media (max-width: 500px) {
    transform: translateX(-20%);
  }
`

export const DeleteModalOverlay = styled.div`
  position: absolute;
  top: 45px;
  right: 0;
  z-index: 1000;
  min-width: 350px;

  @media (max-width: ${mediumScreen}) {
    right: 5px;
    top: 40px;
    min-width: 300px;

    min-width: 300px;
  }
`

export const DeleteModalContent = styled.div`
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`

export const DeleteModalTitle = styled.text`
  color: ${({ theme }) => theme.colors.modalHeader};
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
  text-transform: uppercase;
`

export const DeleteModalMessage = styled.p`
  margin: 10px 0px;
  font-size: small;
`

export const ActionButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.primary};
  border-color: ${({ theme }) => theme.colors.primary};
  color: white;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDarken};
    border-color: ${({ theme }) => theme.colors.primaryDarken};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const PopoverContent = styled.div`
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`

export const PopoverHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  padding: 12px 16px;
  font-weight: 500;
  font-size: 14px;
`

export const PopoverBody = styled.div`
  padding: 16px;
`

export const PopoverFooter = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  margin-top: 4px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
  }
`

export const Label = styled.label`
  display: block;
  font-weight: 500;
  color: #494949;
  margin-bottom: 4px;
  font-size: 14px;
`

export const NotificationModalBody = styled(PopoverBody)`
  padding: 20px;
  /* min-width: 500px; */
  min-height: auto;
`

export const NotificationSection = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  &:last-child {
    margin-bottom: 0;
  }
`

export const NotificationTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #494949;
  margin-bottom: 12px;
  text-transform: uppercase;
`

export const NotifyMeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 16px;

  .notify-title {
    font-size: 14px;
    font-weight: 600;
    color: #494949;
    text-transform: uppercase;
    margin: 0;
    flex-shrink: 0;
  }

  .radio-options {
    display: flex;
    gap: 20px;

    .form-check {
      display: flex;
      align-items: center;
      margin-bottom: 0;

      input[type='radio'] {
        margin-right: 8px;
      }

      label {
        margin-bottom: 0;
        font-weight: normal;
        cursor: pointer;
        margin-left: 5px;
        text-align: center;
        vertical-align: middle;
      }
    }
  }
`

export const NotificationSettings = styled.div`
  border-radius: 4px;
  margin-top: 12px;
`

export const SettingsRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SettingsGroup = styled.div`
  flex: 1;

  label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    margin-bottom: 4px;
    text-transform: uppercase;
  }

  select {
    width: 100%;
    padding: 2px 8px;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 14px;
    background-color: white;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }
`

export const FormatRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 16px;

  .format-title {
    font-size: 14px;
    font-weight: 600;
    color: #494949;
    text-transform: uppercase;
    margin: 0;
    flex-shrink: 0;
  }

  .format-options {
    display: flex;
    gap: 20px;

    .form-check {
      display: flex;
      align-items: center;
      margin-bottom: 0;

      input[type='radio'] {
        margin-right: 6px;
      }

      label {
        margin-bottom: 0;
        font-weight: normal;
        cursor: pointer;
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
`
export const TitleLink = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`
